import React from 'react';

export default function Loader(props){
    return (
        <div className='loader'>
            <i className={`fas fa-spin fa-circle-notch fa-${props.size ? props.size : '5x'}`}></i>
        </div>
    );
}
